import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { logout, refreshSession } from '../actions/constants'
import { Question } from '../../models/value_meter_question'

export interface IValueMeterFormsState {
  houseHoldValueMeterForm?: Record<string, Question>
  rebuildValueMeterForm?: Record<string, Question>
  isLoading: boolean
}

const initialState: IValueMeterFormsState = {
  houseHoldValueMeterForm: undefined,
  rebuildValueMeterForm: undefined,
  isLoading: false
}

export const valueMeterFormsSlice = createSlice({
  name: 'valueMeterForms',
  initialState,
  reducers: {
    setHouseHoldValueMeterForm: (state, action: PayloadAction<Record<string, Question>>) => {
      state.houseHoldValueMeterForm = action.payload
    },
    setRebuildValueMeterForm: (state, action: PayloadAction<Record<string, Question>>) => {
      state.rebuildValueMeterForm = action.payload
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState)
      .addCase(refreshSession, () => initialState)
  }
})

export const {
  setHouseHoldValueMeterForm,
  setRebuildValueMeterForm,
  setIsLoading
} = valueMeterFormsSlice.actions

export default valueMeterFormsSlice.reducer
